module.exports = __webpack_public_path__ + "img/scientist.4cb43a38.svg";